module.exports = __webpack_public_path__ + "static/img/loginbg.d9cbf46.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/loginbg.jpg
// module id = GH5D
// module chunks = 1